import React, { useContext } from "react";
import PermissionItem from "./PermissionItem";

import { useState } from "react";
import { useEffect } from "react";

import { FaFolderOpen, FaLayerGroup } from "react-icons/fa";
import { Col, Row } from "react-bootstrap";

import Tooltip from "rc-tooltip";
import {
  getRoles,
  getMenuByRole,
  updatePermissionByRole,
} from "app/services/permissionService";
import { AppContext } from "app/appContext";

const Permission = () => {
  const context = useContext(AppContext);

  const [isCollapseAll, setIsCollapseAll] = useState(false);
  const [isExpandAll, setIsExpandAll] = useState(false);
  const [permissionState, setPermissionState] = useState([]);
  const [roleState, setRoleState] = useState([]);
  const [roleIdState, setRoleIdState] = useState(1);

  const roleHandler = async () => {
    const roles = await getRoles();

    setRoleState(roles.data);
  };

  const getMenuByRoleHandler = async () => {
    const data = await getMenuByRole(roleIdState);
    //console.log(data);
    setPermissionState(data.data);
  };

  const updatePermission = async (id, type, accessParam) => {
    const updatePermissionReq = {
      menuId: id,
      type: type,
      access: accessParam,
      // canView: item.permission.canView,
      // canAdd: item.permission.canAdd,
      // canEdit: item.permission.canEdit,
      // canDelete: item.permission.canDelete,
    };

    const data = await updatePermissionByRole(roleIdState, updatePermissionReq);

    setPermissionState(data.data);
  };

  useEffect(() => {
    getMenuByRoleHandler();
  }, [roleIdState]);

  useEffect(() => {
    roleHandler();
  }, [context?.navData]);

  return (
    <>
      <div className="mb-1">
        <Row>
          <Col xs={12} md={8}>
            <div className="d-flex justify-content-between">
              <select
                className="form-control w-50"
                onChange={(e) => setRoleIdState(e.target.value)}
              >
                {roleState?.map((role, i) => {
                  return (
                    <option key={i} value={role?.roleId}>
                      {role?.roleName}
                    </option>
                  );
                })}
              </select>

              <div>
                <Tooltip placement="top" overlay={<span>Collapse all</span>}>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-xs me-2"
                    onClick={() => {
                      setIsCollapseAll(!isCollapseAll);
                    }}
                  >
                    <FaLayerGroup />
                  </button>
                </Tooltip>
                <Tooltip placement="top" overlay={<span>Expand all</span>}>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-xs ml-1"
                    onClick={() => setIsExpandAll(!isExpandAll)}
                  >
                    <FaFolderOpen />
                  </button>
                </Tooltip>
              </div>
            </div>
            <hr className="my-3" />
          </Col>
          <Col md={4}></Col>
        </Row>

        {/* header */}

        <Row>
          <Col xs={12} md={8} className="bg-primary">
            <Row>
              <Col xs={6} lg={8}>
                <div className="ml-4 text-white p-1">Menu</div>
              </Col>
              <Col
                xs={6}
                lg={4}
                className="text-white d-flex justify-content-end p-1"
              >
                <div className="px-1">View</div>
                <div className="px-1">Add</div>
                <div className="px-1">Edit</div>
                <div className="px-1">Delete</div>
              </Col>
            </Row>
          </Col>
          <Col md={4}></Col>
        </Row>
      </div>
      {permissionState?.map((item) => (
        <PermissionItem
          updatePermission={updatePermission}
          key={item.id}
          item={item}
          permissionState={permissionState}
          setPermissionState={setPermissionState}
          isCollapseAll={isCollapseAll}
          isExpandAll={isExpandAll}
        />
      ))}
    </>
  );
};

export default Permission;
